import React, { ReactNode } from "react"
import clsx from "clsx"

interface CardProps{
    className:string,
    children?:ReactNode
}
export function Card({ className, children, ...props }:CardProps) {
    return (
        <div
            className={clsx(
                "rounded-2xl border bg-white/60 backdrop-blur-md shadow-sm transition-all",
                "hover:shadow-primary-700/20",
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}
